/**
 * created by li si yi
 *工作日程
 */
import React, {Component} from 'react';
import {Calendar, Modal, Input, Button, message, Popconfirm, Icon, Empty,} from 'antd';
import {Scrollbars} from "react-custom-scrollbars";
import moment from 'moment';
import {permissionCheck, uuid} from "../../../../utils";
import {connect} from "react-redux";
import BaseComponent from "../../../../base/BaseComponent";

const {TextArea} = Input;

class OrderDay extends BaseComponent {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.state = {
            currentClick: '',
            visible: false,
            dataSource: [],
            value: moment(),
            modalList: [
                /* {title: '国庆节', type: 0},
                 {title: '运动会', type: 1},
                 {title: '拜访刘老师', type: 2},
                 {title: '国庆节', type: 3},
                 {title: '运动会', type: 1},
                 {title: '拜访刘老师', type: 2},
                 {title: '国庆节', type: 0},
                 {title: '运动会', type: 1},*/
            ],
            inputVal: '',
            currentDay: moment().format('DD'),
            days: []
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.getCalendarByYearAndMonth();
        this.renderDateList();
        // this.currentDay();
    }

    // 获取工作日程列表
    getCalendarByYearAndMonth() {
        let year = this.state.value.format('YYYY');
        let month = this.state.value.format('MM');
        let day = this.state.value.format('DD');
        let params = {
            year: year,
            month: month
        };
        this.request({
            url: '/cm-sites-sys/calendar/getCalendarByYearAndMonth',
            body: params,
            callBack: (res) => {
                let dataSource = [];
                let modalList = [];
                //初始化modalList
                if (res && res.length) {
                    dataSource = res;
                    if (day < dataSource.length || day == dataSource.length) {
                        modalList = dataSource[day - 1].dayInfo;
                    }
                }
                this.setState({dataSource, modalList})
            }
        })
    };

    render() {
        let showSchoolCalendar = permissionCheck("pms:orderDaySchoolCalendar:viewBtn");//是否校历添加按钮和删除按钮
        let addCalendarBtnName = this.sysConfigGetValueByKey("newDesktop.orderDay.addCalendarBtnName", "添加校历");//添加校历按钮名称
        let color = this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3");

        let {value} = this.state;
        return (
            <div style={{height: 517}} className={'customCalender'}>
                <div style={{backgroundColor: '#fff', borderRadius: '5px'}}>
                    <div style={{
                        borderBottom: '1px solid rgb(204, 204, 204)',
                        padding: '16px 24px',
                        fontSize: '16px',
                        fontWeight: 400,
                        color: 'rgba(0, 0, 0, 0.85)'
                    }}>工作日程
                    </div>
                    <Calendar
                        defaultValue={this.state.value}
                        value={this.state.value}
                        dateCellRender={this.dateCellRender}
                        onSelect={(e) => {
                            this.dateSelect(e)
                        }}
                        onChange={(e) => {
                            this.dateOnChange(e)
                        }}/>
                    <style>
                        {
                            `
                             .events {
                              list-style: none;
                              margin: 0;
                              padding: 0;
                            }
                            .events .ant-badge-status {
                              overflow: hidden;
                              white-space: nowrap;
                              width: 100%;
                              text-overflow: ellipsis;
                              font-size: 12px;
                            }
                            .notes-month {
                              text-align: center;
                              font-size: 28px;
                            }
                            .customCalender{
                               border-radius:5px;
                            }
                            .notes-month section {
                              font-size: 28px;
                            }
                            .customCalender .ant-radio-group{
                             display:none;
                            }
                            .customCalender .ant-fullcalendar-content{
                             // height:44px !important;
                             overflow-y: visible !important;
                            }
                            .customCalender .ant-fullcalendar-date{
                             height:32px !important;
                             border:none;
                            }
                            .customCalender .ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-month, .customCalender .ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-date{
                            background:${color};
                            border-radius:50%;
                            // margin:0px 13px;
                            // height:32px !important;
                            width:31px;
                            }
                            // .customCalender .ant-fullcalendar-selected-day:hover{
                            // background:${color} !important;
                            // border-radius:50%;
                            // }
                            .customCalender .ant-fullcalendar-fullscreen .ant-fullcalendar-month-panel-selected-cell .ant-fullcalendar-value, .customCalender .ant-fullcalendar-fullscreen .ant-fullcalendar-selected-day .ant-fullcalendar-value{
                             color:#fff !important;
                             display:flex;
                             justify-content: center;
                             align-self: center;
                            }
                            .customCalender .ant-fullcalendar-fullscreen .ant-fullcalendar-value{
                                text-align:center;
                                // vertical-align: middle;
                            }
                            .customCalender .ant-fullcalendar-fullscreen .ant-fullcalendar-column-header{
                                text-align:center;
                                padding-Right:0;
                            }
                            .customCalender .ant-fullcalendar-fullscreen .ant-fullcalendar-month:active{
                                background:rgba(0,0,0,0) !important;
                            }
                            // .customCalender .ant-fullcalendar-fullscreen .ant-fullcalendar-date:hover{
                            //     background:red !important;
                            // }
                            // .customCalender .ant-select-selection {
                            //     background:#f6f8fd;
                            // }
                            .customCalender .ant-fullcalendar-header{
                              margin-top:-55px;
                            }
                            .customCalender .ant-fullcalendar-calendar-body{
                             padding:10px 52px;
                            }
                            .customCalender .ant-fullcalendar-selected-day{
                             text-align: -webkit-center;
                             display: flex;
                             justify-content: center;
                            }
                            .customCalender .ant-fullcalendar-today .ant-fullcalendar-value{
                             color:${color};
                            }
                            .customCalender .ant-fullcalendar-fullscreen .ant-fullcalendar-content{
                               height:0 !important;
                            }
                            .customCalender .ant-empty-image{
                            height: 35px !important;
                            }
                            .customCalender .ant-fullcalendar table{
                            height:220px !important;
                            }
                        `
                        }
                    </style>
                    {this.renderDateList()}
                </div>
                <Modal
                    title={this.state.currentClick}
                    visible={this.state.visible}
                    onOk={this.handleOk}
                    onCancel={() => {
                        this.setState({inputVal: "", visible: false, cancelKey: uuid()})
                    }}
                    key={this.state.cancelKey}
                    width={800}
                    bodyStyle={{height: '370px'}}
                    footer={
                        [
                            <TextArea rows={4} style={{height: 65, width: 720, background: '#f6f8fd', marginTop: 10}}
                                      placeholder="请输入"
                                      value={this.state.inputVal} onChange={(e) => {
                                this.setState({inputVal: e.target.value})
                            }}/>,
                            <div style={{textAlign: 'center', marginTop: 10}}>
                                {
                                    showSchoolCalendar ? <Button key={0} onClick={() => {
                                        this.addOrderDay(2)
                                    }}>{addCalendarBtnName}</Button> : null
                                }
                                <Button key={1} key={Date.now()} type="primary" onClick={() => {
                                    this.addOrderDay(3)
                                }}>添加日程</Button>
                            </div>
                        ]
                    }
                >
                    <div style={{height: 320, marginTop: '20px'}}>
                        <Scrollbars autoHide autoHeightMax={250}>
                            <div style={{paddingLeft: 15}}>
                                {
                                    this.state.modalList && this.state.modalList.length ? this.state.modalList.map((item, i) => {
                                        let showDeleteBtn;
                                        let mark = '';
                                        let color = '';
                                        switch (item.type) {
                                            case 0:
                                                mark = '节日/节气';
                                                color = 'red';
                                                break;
                                            case 1:
                                                mark = '任务';
                                                color = '#faad14';
                                                showDeleteBtn = false;
                                                break;
                                            case 2:
                                                mark = '校历';
                                                color = 'green';
                                                showDeleteBtn = showSchoolCalendar;
                                                break;
                                            case 3:
                                                mark = '日程';
                                                color = 'blue';
                                                showDeleteBtn = true;
                                                break;
                                        }
                                        let background;
                                        switch (item.type) {
                                            case 2:
                                                background = '#F0A738';
                                                break;
                                            case 3:
                                                background = '#89D069';
                                                break;
                                            default:
                                                background = '#F56C6C';
                                                break;
                                        }
                                        return (
                                            <div
                                                style={{
                                                    display: 'flex',
                                                    marginTop: 10,
                                                    marginBottom: '24px',
                                                    alignItems: 'center'
                                                }}
                                                key={i}>
                                                <div style={{display: 'flex', borderRadius: '5px', minHeight: 55}}>
                                                    <div style={{
                                                        width: 5,
                                                        minHeight: 55,
                                                        background: background,
                                                        borderTopLeftRadius: '5px',
                                                        borderBottomLeftRadius: '5px'
                                                    }}/>
                                                    <div style={{
                                                        display: 'flex',
                                                        alignItems: 'center',
                                                        background: '#f6f8fd',
                                                        minHeight: 55,
                                                        padding: '5px 35px 5px 15px',
                                                        width: '720px',
                                                        wordBreak: 'break-all',
                                                        overflow: 'hidden',
                                                        textOverflow: 'ellipsis',
                                                        borderRadius: '5px',
                                                        whiteSpace: 'pre-wrap'
                                                    }}>{item.name}
                                                    </div>
                                                </div>
                                                {item.type === 2 && showSchoolCalendar ?
                                                    <Popconfirm
                                                        title="确定要删除吗?"
                                                        onConfirm={() => this.confirm(item)}
                                                        onCancel={this.cancel}
                                                        okText="确定"
                                                        cancelText="取消">
                                                        <Icon key={Date.now()} type="close"
                                                              style={{marginLeft: '-25px'}}/>
                                                    </Popconfirm>
                                                    :
                                                    item.type === 3 ? <Popconfirm
                                                        title="确定要删除吗?"
                                                        onConfirm={() => this.confirm(item)}
                                                        onCancel={this.cancel}
                                                        okText="确定"
                                                        cancelText="取消">
                                                        <Icon key={Date.now()} type="close"
                                                              style={{marginLeft: '-25px'}}/>
                                                    </Popconfirm> : null
                                                }
                                            </div>
                                        )
                                    }) : <Empty style={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        marginTop: 80,
                                        marginBottom: '24px',
                                        alignItems: 'center'
                                    }}/>
                                }
                            </div>
                        </Scrollbars>
                    </div>
                </Modal>
            </div>
        )
    }

    confirm(item) {
        this.delSchedule(item)
    }

    cancel(e) {
        console.log(e);
    }

    //日期变化
    dateOnChange(e) {
        message.destroy();
        if (e.format('YYYY') < 2019) {
            message.error('最小不能小于2019！');
            return false
        }
        if (e.format('YYYY') > 2049) {
            message.error('最大不能大于2049！');
            return false
        }
        this.state.value = e;
        this.state.inputVal = '';
        this.setState({currentClick: e.format('YYYY-MM-DD')});
        this.getCalendarByYearAndMonth();
    }

    // 日期列表
    renderDateList = () => {
        return (
            <div style={{borderTop: '1px solid rgb(204, 204, 204)', padding: '10px 15px'}}>
                <ul style={{padding: 0}}>
                    <li style={{
                        // width: 488,
                        marginBottom: 10,
                        borderRadius: '5px',
                        background: '#f6f8fd',
                        listStyle: 'none',
                        cursor: 'pointer',
                        textAlign: 'center',
                        padding: '7px 0',
                        color: '#AAAAAA'
                    }} onClick={() => {
                        this.setState({visible: true})
                    }}><Icon key={Date.now()} type="plus" style={{marginRight: 7}}/><span>添加</span></li>
                    <Scrollbars autoHide style={{height: '134px'}}>
                        {
                            this.state.modalList.length ? this.state.modalList && this.state.modalList.map((item, index) => {
                                let background;
                                switch (item.type) {
                                    case 2:
                                        background = '#F0A738';// 校历
                                        break;
                                    case 3:
                                        background = '#89D069';// 日程
                                        break;
                                    default:
                                        background = '#F56C6C';// 节日
                                        break;
                                }
                                return (
                                    <li key={index} style={{
                                        display: 'flex',
                                        borderRadius: '5px',
                                        minHeight: 55,
                                        width: '100%',
                                        marginBottom: 18,
                                    }}>
                                        <div style={{
                                            width: 5,
                                            minHeight: 55,
                                            background: background,
                                            borderTopLeftRadius: '5px',
                                            borderBottomLeftRadius: '5px'
                                        }}/>
                                        <div style={{
                                            display: 'flex',
                                            alignItems: 'center',
                                            flexWrap: 'wrap',
                                            background: '#f6f8fd',
                                            padding: '5px 10px 5px 15px',
                                            // overflow: 'hidden',
                                            width: '100%',
                                            minHeight: 55,
                                            wordBreak: 'break-all',
                                            textOverflow: 'ellipsis',
                                            borderRadius: '5px',
                                            whiteSpace: 'pre-wrap'
                                        }}
                                            // dangerouslySetInnerHTML={{__html: item.name.replace(/\n/g, "<br/>")}}
                                        >
                                            {item.name}
                                        </div>
                                    </li>
                                )
                            }) : <Empty style={{alignSelf: 'center', marginTop: '35px'}}/>
                        }

                    </Scrollbars>

                </ul>
            </div>
        )
    };
    getListData = (value, title) => {
        let listData;
        let date = value.format('DD');//value.date();
        //moment().format('YYYY-MM-DD HH:mm:ss')
        let currentMonth = this.state.value.format('MM');
        let valMonth = value.format('MM');
        if (valMonth != currentMonth) {
            return [];
        }
        // console.log(currentMonth, valMonth, date)
        this.state.dataSource.forEach(item => {
            if (item.day == date) {
                listData = item.dayInfo;
            }
        });
        /*switch (date) {
            case 8:
                listData = [
                    {type: 'warning', content: 'This is warning event.'},
                    {type: 'success', content: 'This is usual event.'},
                ];
                break;
            case 10:
                listData = [
                    {type: 'warning', content: 'This is warning event.'},
                    {type: 'success', content: 'This is usual event.'},
                    {type: 'error', content: 'This is error event.'},
                ];
                break;
            case 15:
                listData = [
                    {type: 'warning', content: 'This is warning event'},
                    {type: 'success', content: 'This is very long usual event。。....'},
                    {type: 'error', content: 'This is error event 1.'},
                    {type: 'error', content: 'This is error event 2.'},
                    {type: 'error', content: 'This is error event 3.'},
                    {type: 'error', content: 'This is error event 4.'},
                ];
                break;
            default:
        }*/
        return listData || [];
    };
    getDayTitle = (value) => {
        let listData;
        let title;
        let date = value.format('DD');//value.date();
        //moment().format('YYYY-MM-DD HH:mm:ss')
        let currentMonth = this.state.value.format('MM');
        let valMonth = value.format('MM');
        if (valMonth != currentMonth) {
            return [];
        }
        this.state.dataSource.forEach(item => {
            if (item.day == date) {
                // listData = item.dayInfo;
                if (item.workholiday === '1') {
                    return title = '休'
                } else {
                    title = ''
                }
            }
        });

        return title;
    };

    dateCellRender = (value) => {
        const listData = this.getListData(value);
        const dayTitle = this.getDayTitle(value);
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#1890ff') : '#1890ff';
        let str = [];
        if (listData && listData.length) {
            listData.forEach((item) => {
                str.push(item.name);
            })
        }
        return (
            <div style={{
                // height: 30,
                overflow: 'hidden',
                textOverflow: 'ellipsis',
                whiteSpace: 'nowrap',
                display: 'flex',
                justifyContent: 'center',
            }}
                 title={str.join("，")}>
                <div style={{
                    width: '4px',
                    height: '4px',
                    borderRadius: '50%',
                    background: listData.length > 0 ? this.sysConfigGetValueByKey("newSecondSelectColor", "#0050B3") : '',
                }}/>
            </div>
        );
    };

    //点击日期每一项
    dateSelect(e) {
        this.state.inputVal = '';
        let year = e.format('YYYY');//value.date();
        let month = e.format('MM');
        let params = {
            year: year,
            month: month
        };
        this.setState({currentClick: e.format('YYYY-MM-DD'), modalList: []});
        // this.createCalendar(params, e);
        this.getCalendarByYearAndMonthWithoutLoading(params, e);
    }

    // 创建
    // createCalendar = (params, e, call) => {
    //     this.request({
    //         url: '/cm-sites-sys/calendar/createCalendar',
    //         body: params,
    //         callBack: () => {
    //             if (call) {
    //                 call();
    //             }
    //         }
    //     })
    // };

    getCalendarByYearAndMonthWithoutLoading(params, e) {
        let day = e.format('DD');
        let modalList = [];
        this.request({
            url: '/cm-sites-sys/calendar/getCalendarByYearAndMonth',
            body: params,
            callBack: (res) => {
                if (res && res.length > 0) {
                    res.forEach(item => {
                        if (item.day == day) {
                            modalList = item.dayInfo ? item.dayInfo : [];
                        }
                    })
                }
                this.setState({currentClick: e.format('YYYY-MM-DD'), modalList: modalList, days: res});
            }
        })
    }

    addOrderDay(type) {
        message.destroy();
        let dateList = this.state.currentClick.split('-');
        if (dateList.length < 2) {
            dateList = (moment().format('YYYY-MM-DD')).split('-');
        }
        // console.log(dateList);
        let year = dateList[0];//this.state.currentClick.format('YYYY');
        let month = dateList[1];//this.state.currentClick.format('MM');
        let day = dateList[2];//;this.state.currentClick.format('DD');
        if (!this.state.inputVal.trim()) {
            message.error('请输入内容！');
            return;
        }
        this.setState({visible: false});
        let params = {
            "year": year,
            "month": month,
            "day": day,
            "name": this.state.inputVal,
            "type": type
        };
        this.addSchedule(params);
    }

    //删除功能
    delSchedule(item) {
        let params = {id: item.id};
        this.deleSchedule(params);
        // this.setState({visible: false});//删除不关闭
        this.getCalendarByYearAndMonth()
    }

    //添加
    addSchedule(params, callBack) {
        message.destroy();
        this.request({
            url: '/cm-sites-sys/calendar/addSchedule',
            method: 'post',
            body: params,
            contentType: 'json',
            callBack: (res) => {
                // console.log(res);
                if (res) {
                    message.success('添加成功');
                    this.state.inputVal = '';
                    this.getCalendarByYearAndMonth()
                }
            }
        })

    }

    //删除
    deleSchedule(params, callBack) {
        this.request({
            url: '/cm-sites-sys/calendar/delSchedule',
            body: params,
            callBack: (res) => {
                if (res) {
                    message.destroy();
                    message.success('删除成功');
                    // this.state.inputVal = '';
                    this.getCalendarByYearAndMonth();
                }
            }
        })
    }

}

function mapStateToProps(state) {
    return {
        config: state.systemReducer.config,
    }
}

export default connect(mapStateToProps)(OrderDay);